import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/marketing/seo-services")({ beforeLoad: redirectTo("/marketing/search-seo") });
